import { useEffect, type ReactNode } from 'react';

import { PushDevicePrompt } from './push-device-prompt';
import { registerPushOnce } from './register-push';

/** Background push sync and optional post-login device prompt. */
export function useRegisterPush(enabled: boolean): ReactNode {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    void registerPushOnce();
  }, [enabled]);

  return enabled ? <PushDevicePrompt enabled={enabled} /> : null;
}
